import auth from '@auth/store/auth'
import user from '@auth/store/user'
import swap from '@buyback/modules/Swap'
import { checkoutStore as checkout } from '@checkout'
import { store as toast } from '@core/components/Toast'
import customerRequestDiagnosis from '@customer-requests/Diagnosis/store/store'
import http from '@http/store'
import { ratesStore as rates, store as reviews } from '@internal-reviews'
import reviewform from '@internal-reviews/components/Form/store'
import { store as reviewpage } from '@internal-reviews/components/Page'
import { landing, search } from '@landing/store'
import gdpr from '@legal/store'
import listings from '@merchant/pages/listings/store'
import opportunity from '@merchant/pages/opportunities/store'
import sourcing from '@merchant/pages/sourcing/store'
import pricingTool from '@merchant/shared/PricingTool/store'
import merchant from '@merchant/store'
import { store as myOrders } from '@my-orders'
import payment from '@payment/store'
import product from '@product/store'
import { store as customerRequestDiscussion } from '@sav-discussion'
import { store as customerRequestPlatform } from '@sav-platform'

import config from './modules/config'
import countryConfig from './modules/countryConfig'
import layout from './modules/layout'

export const modules = {
  auth,
  checkout,
  config,
  countryConfig,
  customerRequestDiagnosis,
  customerRequestDiscussion,
  customerRequestPlatform,
  gdpr,
  http,
  landing,
  layout,
  listings,
  merchant,
  myOrders,
  opportunity,
  pricingTool,
  payment,
  product,
  rates,
  reviewform,
  reviewpage,
  reviews,
  sourcing,
  swap,
  toast,
  user,
  // We register the same module twice because we need the same features in different places. Instead of managing every
  // possible context from the Vuex module itself, we create a context-less module, and use it several times. #SOLID
  landingSearch: search,
  searchBar: search,
}
